import React from 'react';
import { Select, InputNumber } from 'antd';
import { generateOptions } from '../../../shared/selectFn';
import { SymbolType } from '../constants';

const SymbolTypeOption = generateOptions(SymbolType);

export default function VisitWindow(props) {
    const { data, style = {}, symbolProp, valueProp, onChange, unit } = props;
    return (
        <div style={style}>
            <Select
                style={{ width: 40 }}
                value={data[symbolProp]}
                onChange={value => onChange(value, symbolProp)}
            >
                {SymbolTypeOption}
            </Select>
            <InputNumber
                min={0}
                precision={0}
                placeholder="请输入"
                style={{ marginLeft: 10, width: 126 }}
                value={data[valueProp]}
                onChange={value => onChange(value, valueProp)}
            />
            <spin style={{ marginLeft: 10 }}>{unit}</spin>
        </div>
    );
}       


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/visitPeriodPlan/components/VisitWindow.js